<template>
    <div class="row">
        <!-- PATIENTS -->
        <div class="col-sm-6 col-md-12 col-lg-6 mb-25">
            <div class="card h-100 border-0 rounded-0 bg-white letter-spacing lead-info-box rounded-0">
                <div class="card-body p-15 p-sm-20 p-md-25 stats-box">
                    <div class="d-flex align-items-center">
                        <div class="icon position-relative rounded-circle text-center flex-shrink-0 text-primary"><i
                                class="ph ph-users-four"></i></div>
                        <div class="title ms-15"><span
                                class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis">{{
                                    $t('feature.home.$stats.total_patients') }}</span>
                            <h4 class="fw-black mb-8 lh-1">{{ stats?.patients_total ?? '-' }}</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- CAREGIVERS -->
        <div class="col-sm-6 col-md-12 col-lg-6 mb-25">
            <div class="card h-100 border-0 rounded-0 bg-white letter-spacing lead-info-box rounded-0">
                <div class="card-body p-15 p-sm-20 p-md-25 stats-box">
                    <div class="d-flex">
                        <div class="icon position-relative rounded-circle text-center flex-shrink-0 text-info"><i
                                class="ph ph-user-circle-plus"></i></div>
                        <div class="title ms-15"><span
                                class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis">{{
                                    $t('feature.home.$stats.total_caregivers') }}</span>
                            <h4 class="fw-black mb-8 lh-1">{{ stats?.caregivers_total ?? '-' }}</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- HCP -->
        <div class="col-sm-6 col-md-12 col-lg-6 mb-25">
            <div class="card h-100 border-0 rounded-0 bg-white letter-spacing lead-info-box rounded-0">
                <div class="card-body p-15 p-sm-20 p-md-25 stats-box">
                    <div class="d-flex align-items-center">
                        <div class="icon position-relative rounded-circle text-center flex-shrink-0 text-danger"><i
                                class="ph ph-stethoscope"></i></div>
                        <div class="title ms-15"><span
                                class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis">{{
                                    $t('feature.home.$stats.total_hcps') }}
                            </span>
                            <h4 class="fw-black mb-8 lh-1">{{ totalHcps ?? '-' }}</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import API from '@/services/api/api.service';
import { CenterStats } from '@/utils/models/center.model';
import { defineComponent } from 'vue';

export default defineComponent({
    name: "CenterStats",
    props: {
        id: {
            type: [String, Number],
            required: true
        }
    },
    data() {
        return {
            stats: undefined as CenterStats | undefined
        }
    },
    mounted() {
        this.loadStats();
    },
    computed: {
        totalHcps(): number | undefined {
            try {
                return this.stats == undefined ? undefined : this.stats?.users_count?.map((data) => data.count)?.reduce((a, b) => a + b, 0) ?? 0;
            } catch (error) {
                return 0;
            }
        }
    },
    methods: {
        loadStats() {
            API.getCenterStats(this.id).then((response) => {
                if (response.data.success === true) {
                    this.stats = (response.data.data ?? []).shift();
                }
            })
        }
    }
});
</script>